'use strict';

var _ = require('underscore');
var Backbone = require('dibs-backbone');

/**
 * @class ModalCarouselUIState
 */
var ModalCarouselUIState = module.exports = Backbone.Model.extend({});

_.extend(ModalCarouselUIState.prototype, {
    defaults: function () {
        return {
            selectedImage : ''
        };
    },
    /**
     * @param {string} image
     */
    setSelectedImage: function (image) {
        this.set({'selectedImage': image});
    },
    /**
     * @returns {string}
     */
    getSelectedImage: function () {
        return this.get('selectedImage');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Carousel/ModalCarouselUIState.js
// module id = 1575
// module chunks = 4 7